<template lang="pug">
.post-content__section(
  :class="classes"
  :tabindex="canEdit ? 0 : false"
  v-html="renderContent"
  @focus="onFocus"
  @blur="onBlur"
  @keyup.up="$emit('keyup', $event)"
  @keyup.down="$emit('keyup', $event)"
)
</template>

<script>
export default {
  name: 'default-section',
  props: {
    section: {
      type: Object,
      default: null,
    },
    canRemove: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inFocus: false,
    }
  },
  computed: {
    classes() {
      return { 
        '--text': this.section.kind === 'text',
        '--html': this.section.kind === 'html',
        '--focus': this.inFocus 
      }
    },
    renderContent() {
      return typeof this.section === 'string' 
        ? this.section.replace(/\n/g, '<br/>') 
        : this.section.content.replace(/\n/g, '<br/>')
    }
  },
  methods: {
    focus() {
      this.$el.focus()
    },
    onFocus() {
      this.inFocus = true
    },
    onBlur() {
      this.inFocus = false
    }
  },
}
</script>

<style lang="sass">
.post-content__section
  margin-top: 2rem
  margin-bottom: 2rem
</style>
